/**
 * mobile-answer-list.js
 */

import React from 'react';
import { Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useParams } from "react-router-dom";
import { Types } from 'utils/constants';
import { UserContext } from 'contexts/user/user-context';
import useRecordStore from 'contexts/record-store';
import AnswerMenuItem from 'components/training/answer/menu-item';


const useStyles = makeStyles(theme => ({
  answerRows: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(6),
    '& .rows-title': {
      margin: `${theme.spacing(1)} ${theme.spacing(2.5)}`,
      textTransform: 'uppercase',
      color: theme.palette.primary.colors[4],
      fontSize: theme.typography.sizes[1],
      fontWeight: 600,
    }
  },
}));


export default function MobileAnswerList(props) {
  const {
    basePath,
  } = props;
  const classes = useStyles();
  const { user } = React.useContext(UserContext);
  const params = useParams();
  const exerciseId = params.exerciseId || 0;
  const recordStore = useRecordStore();
  const exerciseRecord = recordStore.useRecord(Types.Record.EXERCISE, exerciseId).ornull;
  const eventRecord = recordStore.useRecord(Types.Record.EVENT, exerciseRecord?.get()?.eventId);
  const answerIds = exerciseRecord && exerciseRecord.get().answers;
  const answerIdString = JSON.stringify(answerIds)
  const answers = recordStore.useRecordArray(Types.Record.ANSWER, answerIds);
  const {handlerAnswers, membershipDict} = React.useMemo(() => {
    const handlerAnswers = answers.reduce((p, a) => {
      if (!p[a.get().handler.id]) {
        p[a.get().handler.id] = { ...a.get().handler, answerIds: [] };
      }
      p[a.get().handler.id].answerIds.push(a.get().id);
      return p;
    }, {});
    const membershipDict = eventRecord.get().members.reduce((p, a) => {
      p[a.id] = a;
      return p;
    }, {});
    return { handlerAnswers, membershipDict };

  // for max efficiency, using answer id string to trigger changes to answer and membership objects
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answerIdString]);



  return (
    <>
      {/* mobile page answer rows */}
      <div className={classes.answerRows}>
        {(user.role.isSupervisor || user.role.isTrainer) &&
        <div className='rows-title'>
          My {user.role.isSupervisor ? 'Supervised' : 'Trained'} Handlers
        </div>}
        <Divider />
        {Object.entries(handlerAnswers).map(([handlerId, handler]) => (
          <div key={handlerId}>
            {handler.answerIds.map(id => 
              <AnswerMenuItem
                key={id}
                id={id}
                handlerId={+handlerId}
                type='drawer-menu-item'
                membership={membershipDict[handlerId]}
                basePath={basePath}
                showK9Prefix
                showHandlerName={!user.role.isHandler}
              />
            )}
          </div>
        ))}
      </div>
    </>
  );
}